import React, { useState, useEffect } from 'react';
import './courses.css';
import C2wCoursesHoverCard from '../../../common/C2wHome/courses/coursesHoverCard';
import Footer from '../Footer';
// import courseData from '/data/coursesData.json'

function C2wCourses() {


    /**
     * @hook useEffect
     * @author Vishal Lohbande
     * @Date 27-05-2025
     *
     * useEffect - Fetches course data from a local JSON file and updates the component state using `setCourseData`.
     *
     * Behavior:
     * - Runs once on component mount (empty dependency array `[]` ensures this).
     * - Initiates a fetch request to "data/coursesData.json".
     * - Parses the response as JSON.
     * - Updates `coursesData` state with the parsed data on successful fetch.
     * - Logs an error to the console if the fetch fails.
     *
     * Usage Scenario:
     * - Commonly used for initializing UI with static or external data (e.g., course listings).
     * - Ensures data is loaded as soon as the component is rendered.
     *
     * Notes:
     * - `coursesData` should initially be `null` or an empty array depending on rendering logic.
     * - The JSON file should be placed correctly in the public directory (for example, `public/data/coursesData.json` if using Create React App or Vite).
     */
    const [coursesData, setCourseData] = useState(null);
    useEffect(() => {
        fetch("data/coursesData.json")
            .then((res) => res.json())               // parse JSON
            .then((data) => {
                setCourseData(data);
            })
            .catch((err) => {
                console.error("Failed to fetch course details:", err);
            });
    }, []);


    /**
     * @constant windowWidth
     * @author Vishal Lohbande
     *
     * Description:
     * - Stores the current width of the browser window in state.
     * - Initialized with the window's initial inner width.
     */
    /**
     * @function useEffect Hook for window resize listener
     * @author Vishal Lohbande
     *
     * Description:
     * - Sets up an event listener for the window's `resize` event on component mount.
     * - Updates `windowWidth` state whenever the window is resized.
     * - Cleans up the event listener on component unmount to avoid memory leaks.
     *
     * Usage:
     * - Useful for responsive components that depend on the window width.
     *
     * Notes:
     * - The effect runs only once on mount due to empty dependency array `[]`.
     */

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    /**
 * @constant renderdCoursesCards
 * @author Vishal Lohbande
 *
 * Description:
 * - Maps over the `courses` array inside `courseData` to render a list of `C2wCoursesHoverCard` components.
 * - Passes each course object as a prop named `obj` to each card.
 *
 * Usage:
 * - Used to display a collection of course cards dynamically based on the `courseData` object.
 *
 * Notes:
 * - Consider adding a unique `key` prop for each rendered component to optimize React rendering.
 */
    const renderdCoursesCards = coursesData?.courses?.map((obj, index) => {
        return <C2wCoursesHoverCard obj={obj} />
    })

    return (
        windowWidth > 620 ?
            <div className='C2wCourses_ctn_route'>
                <div className='C2wCourses_ctn_route_scroller' >
                    {/* <svg className='C2wCoursesRefreshIcon' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 20C9.76667 20 7.875 19.225 6.325 17.675C4.775 16.125 4 14.2333 4 12C4 9.76667 4.775 7.875 6.325 6.325C7.875 4.775 9.76667 4 12 4C13.15 4 14.25 4.23734 15.3 4.712C16.35 5.18667 17.25 5.866 18 6.75V5C18 4.71667 18.096 4.47934 18.288 4.288C18.48 4.09667 18.7173 4.00067 19 4C19.2827 3.99934 19.5203 4.09534 19.713 4.288C19.9057 4.48067 20.0013 4.718 20 5V10C20 10.2833 19.904 10.521 19.712 10.713C19.52 10.905 19.2827 11.0007 19 11H14C13.7167 11 13.4793 10.904 13.288 10.712C13.0967 10.52 13.0007 10.2827 13 10C12.9993 9.71734 13.0953 9.48 13.288 9.288C13.4807 9.096 13.718 9 14 9H17.2C16.6667 8.06667 15.9377 7.33334 15.013 6.8C14.0883 6.26667 13.084 6 12 6C10.3333 6 8.91667 6.58334 7.75 7.75C6.58333 8.91667 6 10.3333 6 12C6 13.6667 6.58333 15.0833 7.75 16.25C8.91667 17.4167 10.3333 18 12 18C13.1333 18 14.171 17.7127 15.113 17.138C16.055 16.5633 16.784 15.7923 17.3 14.825C17.4333 14.5917 17.621 14.4293 17.863 14.338C18.105 14.2467 18.3507 14.2423 18.6 14.325C18.8667 14.4083 19.0583 14.5833 19.175 14.85C19.2917 15.1167 19.2833 15.3667 19.15 15.6C18.4667 16.9333 17.4917 18 16.225 18.8C14.9583 19.6 13.55 20 12 20Z" fill="white" />
                    </svg> */}
                    <div className='C2wCoursesHeading_ctn_hld'>
                        <div className='C2wCoursessHeading_ctn'>
                            {'Explore Popular '}
                            <span className='C2wCorsessHeadingSpan'>{'Courses'}</span>
                        </div>
                        <div className='C2wCourses_ctn_subheading'>{'Boost Your Knowledge and Career'}</div>
                    </div>
                    <div className='C2wCorses_Hover_card_ctn'>
                        {renderdCoursesCards}
                    </div>
                </div>
                 <div className="ADfooter__container courses">
                    <Footer />
                </div>
            </div> :
            <div className='C2wCourses_ctn_route'>
                <div className='C2wCourses_ctn_holder'>
                    <div className='C2wCoursesHeading_ctn_hld'>
                        <div className='C2wCoursessHeading_ctn'>
                            {'Explore Popular '}
                            <span className='C2wCorsessHeadingSpan'>{'Courses'}</span>
                        </div>
                        <div className='C2wCourses_ctn_subheading'>{'Boost Your Knowledge and Career'}</div>
                    </div>
                    <div className='C2wCorses_Hover_card_ctn'>
                        {renderdCoursesCards}
                    </div>

                </div>
                <div className="ADfooter__container courses">
                    <Footer />
                </div>
            </div>
    )
}

export default C2wCourses
